import { createSlice } from '@reduxjs/toolkit';

// /v1/trackables/{trackableId}/events

const initialState = {
  data :[
  {
    id: 21,
    vehicle : "SkutKar #21",
    type: 'Car',
    battery: 24,
    availability: 'available',
    TPMS: 'OK',
    DTC: 'P3245',
    location: { 
      address: {
        city: "City1",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -34.397, 
      longitude: 150.644 
    },
    trackableId : "1657826963564ONP1U4K",
    alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 245,
    vehicle : "SkutKar #245",
    type: 'Scooter',
    battery: 50,
    availability: 'reserved',
    TPMS: 'OK',
    DTC: 'OK',
    location: { 
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -34.297, 
      longitude: 150.444 
    },
    trackableId : '1657900088006AX6UV3O',
    alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 22,
    vehicle : "SkutKar #22",
    type: 'Car',
    battery: 78,
    availability: 'available',
    TPMS: 'Low(LF)',
    DTC: 'OK',
    location: { 
      address: {
        city: "City3",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -34.397, 
      longitude: -34.397,
    },
    trackableId: '165790044824192TKA5O',
    alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 232,
    vehicle : "SkutKar #232",
    type: 'Car',
    battery: 78,
    availability: 'available',
    TPMS: 'OK',
    DTC: 'OK',
    location: { 
      address: {
        city: "City4",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -34.257, 
      longitude: 150.500
     },
     trackableId: '1657900533286O9X4A1R',
     alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 43035,
    vehicle : "Skutr #43035",
    type: 'Scooter',
    battery: 78,
    availability: 'available',
    TPMS: 'Low(LF)',
    DTC: 'OK',
    location: { 
      address: {
        city: "City5",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -36.200, 
      longitude: 100.5
     },
     trackableId: '1657900674170PBJRTS5',
     alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 45,
    vehicle : "SkutKar #45",
    type: 'Car',
    battery: 22,
    availability: 'accident',
    TPMS: 'OK',
    DTC: 'OK',
    location: { 
      address: {
        city: "City1",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -36.100,
       longitude: 100.1
       },
      //  trackableId: '1657900810967PLND5QI',
      trackableId : '16606185321649ZYO0DF',
       alerts :[
        {
          dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
          type : "accident",
          typeVal : "Accident",
          value : ""
        },
        {
          dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
          type : "unauthorizedmovement",
          typeVal : "Unauthorized Movement",
          value : ""
        },
        {
          dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
          type : "battery",
          typeVal : "Battery",
          value : "9"
        },
        {
          dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
          type : "tpms",
          typeVal : "TPMS",
          value : "LOW(LF)"
        },
      ],
  },
  {
    id: 39,
    vehicle : "Skutr #39",
    type: 'Scooter',
    battery: 44,
    availability: 'tripstarted',
    TPMS: 'OK',
    DTC: 'OK',
    location: { 
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -30.200, 
      longitude: 150.5
     },
     trackableId: '165790089413694WQN2I',
     alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 25,
    vehicle : "Skutr #25",
    type: 'Car',
    battery: 44,
    availability: 'tripstarted',
    TPMS: 'OK',
    DTC: 'OK',
    location: { 
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: 30.100, 
      longitude: 100.100
     },
     trackableId: '1657901020419AKI98FU',
     alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 36,
    vehicle : "SkutKar #36",
    type: 'Car',
    battery: 22,
    availability: 'nonresponding',
    TPMS: 'OK',
    DTC: 'OK',
    location: { 
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -30.200, 
      longitude: 150.4
     },
     trackableId:'165790105778280IB3VF',
     alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 690,
    vehicle : "Skutr #690",
    type: 'Scooter',
    battery: 100,
    availability: 'reserved',
    TPMS: 'OK',
    DTC: 'OK',
    location: { 
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: -25.200, 
      longitude: 150.5
     },
     trackableId:'1657901090234GJPDI33',
     alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 61,
    vehicle : "Skutr #61",
    type: 'Scooter',
    battery: 56,
    availability: 'available',
    TPMS: 'OK',
    DTC: 'OK',
    location: {
      address: {
        city: "City3",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: 30.200, 
      longitude: 150.5
    },
    trackableId:'165790044824192TKA5O',
    alerts :[
      {
        dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type : "accident",
        typeVal : "Accident",
        value : ""
      },
      {
        dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type : "unauthorizedmovement",
        typeVal : "Unauthorized Movement",
        value : ""
      },
      {
        dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type : "battery",
        typeVal : "Battery",
        value : "9"
      },
      {
        dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type : "tpms",
        typeVal : "TPMS",
        value : "LOW(LF)"
      },
    ],
  },
  {
    id: 69,
    vehicle : "Skutr #69",
    type: 'Scooter',
    battery: 22,
    availability: 'unauthorizedmovement',
    TPMS: 'OK',
    DTC: 'OK',
    location: { 
      address: {
        city: "City3",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY"
      },
      latitude: 10.200,
      longitude: 150.5 
    },
      trackableId:'1657900810967PLND5QI',
      alerts :[
        {
          dateTime : new Date("2022-08-06 20:12:45.442794").toUTCString(),
          type : "accident",
          typeVal : "Accident",
          value : ""
        },
        {
          dateTime : new Date("2022-07-06 20:12:45.442794").toUTCString(),
          type : "unauthorizedmovement",
          typeVal : "Unauthorized Movement",
          value : ""
        },
        {
          dateTime : new Date("2022-08-05 20:12:45.442794").toUTCString(),
          type : "battery",
          typeVal : "Battery",
          value : "9"
        },
        {
          dateTime : new Date("2022-04-06 20:12:45.442794").toUTCString(),
          type : "tpms",
          typeVal : "TPMS",
          value : "LOW(LF)"
        },
      ],
  },  
  ],
  transformedData :[],
  vListFilter : false,
  vListSearch : false,
  listColumns : [
    {
      Header: "New York Region",
      columns : [            
        {
          Header: "Vehicle",
        accessor : "vehicle",
        disableSortBy: true,
        },
        {
          Header: "Type",
        accessor : "type",
        sortType: 'alphanumeric',
        },
        {
          Header: "Availability",
        accessor : "availability",
        disableSortBy: true,
        },
        {
          Header: "Battery",
        accessor : "battery",
        sortType: 'basic',
        disableSortBy: true,
        
        },
        {
          Header: "TPMS",
        accessor : "TPMS",
        disableSortBy: true,
        },
        {
          Header: "DTC",
        accessor : "DTC",
        disableSortBy: true,
        },
        {
          Header: "Location",
        accessor : "location.address.city",
        disableSortBy: true,
        }
      ]
    }
  ],
  alertListColumns : [
    {
      Header: "Alerts List",
      columns : [            
        {
          Header: "",
          accessor : "dateTime",
          disableSortBy: true,
        },
        {
          Header: "",
          accessor : "type",
          sortType: 'alphanumeric',
        },
        {
          Header: "",
          accessor : "value",
          disableSortBy: true,
        }
      ]
    }
  ],
  alertFilter : false,
  alertSearch : false,
  loggedIn : false,
  tripDetails : [],
};

// Slice
const sktrDetailsSlice = createSlice({
  name: 'sktr',
  initialState: initialState,
  reducers: {
    sktrUpdates: (state, action) => {      
      // state.needsAttention= action.payload;
      // console.log("action.payload");
      // console.log(action.payload);
      state.transformedData= action.payload;
    //   state.needsAttention= action.payload.needsAttention;
    //   console.log("state.needsAttention inside slice");
    //   console.log(state.needsAttention);
    //   console.log("state.availability inside slice");
    //   console.log(state.availabilty);
    },
    vlistFilter : (state, action) => {
      console.log("Entered into vlist filter");
      console.log(state.vListFilter);
      state.vListSearch = false;
      state.vListFilter = !state.vListFilter;
    },
    vlistSearch : (state, action) => {
      state.vListFilter = false;
      state.vListSearch = !state.vListSearch;
    },
    alertFilter : (state, action) => {
      console.log("Entered into alert filter");
      console.log(state.vListFilter);
      state.alertSearch = false;
      state.alertFilter = !state.alertFilter;
    },
    alertSearch : (state, action) => {
      state.alertFilter = false;
      state.alertSearch = !state.alertSearch;
    },
    login : (state, action) => {
      console.log("login handler actions");
      state.loggedIn = true;
    },
    logout: (state, action) => {
      console.log("logout handler actions");
      state.loggedIn = false;
    },
    setVehicleList: (state, action)=> {
      console.log("vehicleList Append");
      state.data = [...state.data, ...action.payload]
    }
  },
});

export default sktrDetailsSlice;
